import logger from 'src/utils/logger/logger';
export default function detection (agent) {
  let comp_agent = agent.indexOf("androidtv cvideo") != -1;
  if (comp_agent) {
    logger.info ("[androidtv detection] detected");
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/androidtv/detection.js